<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Agen/Langganan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.codenama"
              @keyup.13.native="lkuKoranCustShow=true"
              placeholder="Kode atau Nama"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Tanggal Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">s.d.</span>
            </b-input-group-append>
            <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
          </b-input-group>

        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales(AE) | Kolektor</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_codename" placeholder="Sales (AE)"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-form-input v-model="tblData.collector_codename" placeholder="Kolektor" class="ml-2"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCollectShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-row>
            <b-col lg="7">
              <b-input-group >
                <b-input-group-prepend><label>Jenis Gratisan</label></b-input-group-prepend>
                    <b-form-input
                      readonly
                      v-model="tblData.campaignName"
                      @keyup.13.native="lkuKoranCampaignShow"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCampaignShow=true">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group >
                <b-input-group-prepend><label class>Agen/Langganan</label></b-input-group-prepend>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="customerGroups"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <div class="float-right">
            <b-input-group>
              <b-button class="btn btn-success ml-3 mr-1" size="sm" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
              <b-button class="btn btn-secondary" size="sm" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter
              </b-button>
            </b-input-group>
          </div>

        </b-col>
      </b-row>
      <br />
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
            <template v-slot:cell(startdate)="data">
              <span v-if="(data.item.startdate)">{{ data.item.startdate | moment("DD MMM YYYY") }}</span>
            </template>
            <template v-slot:cell(enddate)="data">
              <span v-if="(data.item.enddate)">{{ data.item.enddate | moment("DD MMM YYYY") }}</span>
            </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="tblData.pageOptions"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal
        v-model="lkuKoranCustShow"
        size="lg"
        :hide-footer="true"
        title="List of Agen/Langganan"
        :centered="true"
      >
        <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
      </b-modal>
      <b-modal
        v-model="lkuKoranSalesShow"
        size="lg"
        :hide-footer="true"
        title="List Sales"
        :centered="true"
      >
        <lku-salesae @click="onSelectKoranSales" crudfilter="koran=1"></lku-salesae>
      </b-modal>
      <b-modal
        v-model="lkuKoranCollectShow"
        size="lg"
        :hide-footer="true"
        title="List Kolektor"
        :centered="true"
      >
        <lku-collector @click="onSelectKoranCollect"></lku-collector>
      </b-modal>

      <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    </b-card>
    <b-modal
      v-model="lkuKoranCampaignShow"
      size="lg"
      :hide-footer="true"
      title="List of Campaign"
      :centered="true"
    >
      <lku-koran-campaign @click="onSelectKoranCampaign"></lku-koran-campaign>
    </b-modal>

  </div>
</template>

<script>
import toastr from "mini-toastr";
import Loading from "vue-loading-overlay";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import koran_kiriman from "../../apis/koran_kirim_gratis";
import lkuKoranCampaign from "../lookup/lkuKoranCampaign";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCollector from "../lookup/lkuCollector";

toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuSalesae, lkuCollector,lkuKoranCampaign },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      kota_name: { required },
      area_id: { required }
    }
  },
  data() {
    return {
      isLoading: false,
      showFilter: false,
      showDelConfirm: false,
      lkuKoranCampaignShow:false,
      areas: [],campaigns:[],
      tblData: {
        fields:[
            {
              key: "tanggal",
              label: "Tgl. Kirim",
              thStyle: "width:100px",
              sortable: true
            },
            {
              key: "CustCode",
              label: "Kode",
              sortable: true
            },
            {
              key: "CustName",
              label: "Nama Agen",
              sortable: true
            },
            {
              key: "kiriman_name",
              label: "Jenis Kiriman",
              sortable: true,
            },
            {
              key: "gratis",
              label: "Jml.Gratisan",
                  sortable: true
            },
            {
              key: "kota_name",
              label: "Kota Layanan",
              sortable: true
            },
            {
              key: "jurusan_name",
              label: "Jurusan",
                  sortable: true
            },
          ],
        page: 1,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,        
        sortBy: "CustName",
        sortDesc: false,
        customer_group: null
      },
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranCollectShow: false
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  created: async function() {
    this.customerGroups = [
      { value: null, text: "Semua Group" },
      { value: "KORANAGEN", text: "AGEN" },
      { value: "KORANLANGGANAN", text: "LANGGANAN" }
    ];
    // await customer.group();
    // const a = await crud.list({
    //   tablename: "koranarea",
    //   page: 1,
    //   limit: 1000,
    //   total: 0,
    //   sortBy: "area_name",
    //   sortDesc: false
    // });
    // this.areas = a.reduce((newArr, item) => {
    //   newArr.push({ value: item.area_id, text: item.area_name });
    //   return newArr;
    // }, []);
  },
  methods: {
    onSelectKoranCampaign(_selected) {
      if (_selected && _selected.campaignKey) {
          this.tblData.campaignKey = _selected.campaignKey;
          this.tblData.campaignName = _selected.uraian;
          this.lkuKoranCampaignShow = false;
      }
    },
    onSelectKoranCust: function(_selected) {
      this.tblData.codenama = _selected.CustCode;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranSales: function(_selected) {
      this.tblData.salesae_codename = _selected.crewnik;
      this.lkuKoranSalesShow = false;
    },
    onSelectKoranCollect: function(_selected) {
      this.tblData.collector_codename = _selected.crewnik;
      this.lkuKoranCollectShow = false;
    },
    data: async function(ctx) {
      this.isLoading = true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await koran_kiriman.list(this.tblData);
      this.isLoading = false;
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter() {
      this.tblData.name = null;
      this.tblData.customer_group = null;
      this.tblData.code = null;
      this.tblData.nofaktur = null;
      this.tblData.tgl1 = null;
      this.tblData.tgl2 = null;
      this.tblData.campaignName = '';
      this.tblData.campaignKey = '';
    },
    add: function(data) {
      router.push({ name: "koran.prosespesanan" });
    },
    edit: async function(data) {
      console.log("edit this.model", this.model);
      if (this.model.kirimanKey) {
        router.push({
          name: "koran.prosespesananfrm",
          params: { kirimanKey: this.model.kirimanKey }
        });
      } else {
        toastr.warn("Silahkan pilih data yang ingin diubah!");
      }
    },
    save: async function(callback) {},
    deleteConfirm(item) {
      if (this.model && this.model.kirimanKey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Silahkan pilih data yang ingin dihapus!");
      }
    },
    deleteData: async function() {
      this.isLoading = true;
      try {
        await koran_kiriman.remove(this.model);
        this.isLoading = false;
        this.refresh();
        toastr.success("Data berhasil dihapus");
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await koran_kiriman.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'koran.kirimangratis')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push({name: "koran.home"});
      }

    }
  }
};
</script>